/** React */
import React, {
  Children,
  ComponentType,
  HtmlHTMLAttributes,
  ReactElement,
  ReactNode,
  cloneElement,
  isValidElement,
  useContext,
  useEffect,
  useRef,
} from "react";

/** CSS */
import "./index.css";

/** Hooks */
import { useMenu } from "./menu-root";

/** Utils */
import { generateId } from "./menu-utils";
import { MenuButton } from "./menu-button";
import { MenuContent } from "./menu-content";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

const ALLOWED_CHILD_COMPONENT = [MenuButton.name, MenuContent.name];

export function MenuItem({ children, ...props }: Props) {
  const { addItem } = useContext(useMenu());
  const menuId = useRef<string>("");

  useEffect(() => {
    menuId.current = generateId();

    addItem({
      id: menuId.current,
      isExpanded: true,
    });
  }, []);

  return (
    <div data-menu-id={menuId.current} {...props}>
      {Children.map(children, (child) => {
        if (!isValidElement(child)) return;

        const childComponent = child.type as ComponentType;

        if (!ALLOWED_CHILD_COMPONENT.includes(childComponent.name)) return;

        return cloneElement(child as ReactElement, {
          "data-menu-id": menuId.current,
        });
      })}
    </div>
  );
}
